import { useEffect } from "react";
import { useAdminPageMetaContext } from "../context/AdminPageMetaContext.js";
import type { AdminRouteMeta } from "../lib/adminRouteMeta.js";

/** Override the shell content chrome title/description for dynamic routes. */
export const useAdminPageMeta = (meta: AdminRouteMeta | null) => {
  const { setOverride } = useAdminPageMetaContext();

  useEffect(() => {
    setOverride(meta);
    return () => {
      setOverride(null);
    };
  }, [meta, setOverride]);
};
